import { useState } from 'react';
import { Link } from 'react-router-dom';
import { Cookie, X } from '@phosphor-icons/react';
import { useLanguage } from '@/context/LanguageContext';

const KEY = 'growthriq_cookie_consent';

export default function CookieBanner() {
  const { t } = useLanguage();
  const [show, setShow] = useState(() => {
    if (typeof window === 'undefined') return false;
    try {
      return !localStorage.getItem(KEY);
    } catch {
      return false;
    }
  });

  const accept = () => {
    try { localStorage.setItem(KEY, JSON.stringify({ accepted: true, ts: Date.now() })); } catch { /* ignore */ }
    setShow(false);
  };

  const declineOptional = () => {
    try { localStorage.setItem(KEY, JSON.stringify({ accepted: 'essential', ts: Date.now() })); } catch { /* ignore */ }
    setShow(false);
  };

  if (!show) return null;
  return (
    <div className="fixed bottom-4 left-4 right-4 sm:left-auto sm:right-6 sm:bottom-6 sm:max-w-md z-40" data-testid="cookie-banner">
      <div className="rounded-2xl border border-[#3CD9B8]/30 bg-[#0F1B36] shadow-2xl p-5">
        <div className="flex items-start gap-3">
          <div className="p-2 rounded-lg bg-[#3CD9B8]/10 text-[#3CD9B8]">
            <Cookie size={20} weight="fill" />
          </div>
          <div className="flex-1">
            <h4 className="font-semibold text-white mb-1">{t('cookie.title')}</h4>
            <p className="text-xs text-white/70 leading-relaxed">
              {t('cookie.body')}{' '}
              <Link to="/legal/cookies" className="text-[#3CD9B8] underline">{t('cookie.body.link')}</Link>{t('cookie.body.suffix')}
            </p>
          </div>
          <button onClick={declineOptional} className="text-white/50 hover:text-white" data-testid="cookie-close"><X size={16} /></button>
        </div>
        <div className="flex gap-2 mt-4">
          <button onClick={declineOptional} data-testid="cookie-essential" className="flex-1 px-3 py-2 text-xs rounded-lg border border-white/20 text-white/80 hover:bg-white/5">{t('cookie.essential')}</button>
          <button onClick={accept} data-testid="cookie-accept" className="flex-1 px-3 py-2 text-xs rounded-lg bg-[#3CD9B8] text-[#0F1B36] font-semibold">{t('cookie.accept')}</button>
        </div>
      </div>
    </div>
  );
}
